import { SceneState } from '../../../components/SceneStatemachinePlugin';
import { STRETCHING_ANIMALS, VO_MAP } from '../config/Config';
import { InputTimeoutVO } from '../../../components/InputTimeoutVO';

export class StatePlayfulStretchingPlay extends SceneState {
  startState({ animal }) {
    this.stage = 1;

    this.blueBackground = this.scene.add.image(910, 390, 'background_blue').setAlpha(0);
    this.animalSpine = this._createCharacterSpine(animal, 600, 700);
    this.characterSpine = this._createCharacterSpine('abby', 1200, 700, 0.7, animal);

    this.slider = this.scene.add.image(910, 0, 'playful_stretching', 'slider');
    this.slider.startY = 600;
    this.slider.scale = 0;

    this.trackForSwipe = false;
    this.swipetriggerDistance = 32;

    this.timeout = new InputTimeoutVO(this.scene, { vo: VO_MAP.swipe_prompt });
    this.timeout.on('prompt', this.playPromptAnimation, this);

    // this.activateUserInput();

    this.characterSpine.lipflap = true;
    this.scene.game.vo.playChain([...VO_MAP[`stretch_start_${animal}`]], {
      onComplete: () => {
        this.activateUserInput();
        this.characterSpine.lipflap = false;
        this.scene.game.vo.play(VO_MAP.swipe_prompt);
      },
    });
  }

  _createCharacterSpine(id, x, y, scale, animal) {
    const spine = new PlayfulStretchingCharacter(this.scene, x, y, id, animal);
    spine.setScale(scale || 1);
    spine.id = id;
    spine.on('complete', () => this.handleSpineAnimationComplete(spine), this);
    return spine;
  }

  handlePointerDown(e) {
    this.trackForSwipe = false;
    this.scene.tweens.killTweensOf(this.slider);
    this.slider.alpha = 0;
    this._input = { startY: e.y, lastY: e.y };
    this.addDragListeners();
    this.timeout.disable();
  }

  handlePointerMove(e) {
    const dist = e.y - this._input.lastY;
    if (dist < 0) this.slider.y = Math.max(this.slider.y + dist, 180);
    this._input.lastY = e.y;
    const distTotal = this._input.startY - e.y;
    if (distTotal > this.swipetriggerDistance) {
      this.deactivateUserInput();
      this.handlePointerUp(e);
    }
  }

  handlePointerUp(e) {
    this.removeDragListeners();
    if (e.y < this._input.startY) {
      const dist = e.y - this._input.startY;
      if (Math.abs(dist) > 32) {
        this.handleSwipeComplete();
      } else this.trackForSwipe = e.y;
    } else this.trackForSwipe = e.y;
  }

  handleSwipeComplete() {
    this.trackForSwipe = false;
    this.removeInputListeners();
    this.playSwipeAnimation();
    this.scene.tweens.add({
      targets: this.slider,
      scale: 0,
      duration: 100,
    });
  }

  playSwipeAnimation() {
    if (this.characterSpine.stretchStage == 1) {
      this.characterSpine.lipflap = true;
      this.scene.game.vo.play(VO_MAP.copy_prompt, {
        onComplete: () => {
          this.characterSpine.lipflap = false;
          this.animalSpine.idle = false;
          this.characterSpine.idle = false;
          this.animalSpine.timeScale = this.characterSpine.timeScale = 1;
        },
      });
    } else {
      this.animalSpine.idle = false;
      this.characterSpine.idle = false;
      this.animalSpine.timeScale = this.characterSpine.timeScale = 1;
    }
  }

  handleSpineAnimationComplete(spine) {
    if (!spine.idle) {
      spine.stretchStage++;
      spine.idle = true;
    }

    if (this.animalSpine.idle && this.characterSpine.idle) {
      if (this.characterSpine.stretchStage < 4) {
        // next round

        this.activateUserInput();
      } else {
        // end round
        spine.removeAllListeners('complete');
        this.scene.tweens.add({
          targets: this.blueBackground,
          alpha: 1,
          duration: 500,
          ease: Phaser.Math.Easing.Quadratic.In,
          onComplete: () => {
            this.scene.game.vo.playChain(VO_MAP.complete, {
              onComplete: () => this.emit('state_complete'),
            });
          },
        });
      }
    }
  }

  activateUserInput(force) {
    if (this.userInputEnabled && !force) return;
    this.deactivateUserInput();
    this.timeout.enable();
    this.userInputEnabled = true;
    this.playPromptAnimation(() =>
      this.scene.input.on('pointerdown', this.handlePointerDown, this)
    );
  }

  playPromptAnimation(onComplete) {
    this.slider.y = this.slider.startY;
    this.slider.alpha = 1;
    this.scene.tweens.killTweensOf(this.slider);
    this.scene.tweens.chain({
      tweens: [
        {
          targets: [this.slider],
          scale: { from: 0, to: 1 },
          ease: Phaser.Math.Easing.Back.Out,
          duration: 500,
        },
        {
          targets: [this.slider],
          y: { from: this.slider.startY, to: this.slider.startY - 300 },
          ease: Phaser.Math.Easing.Quadratic.Out,
          duration: 1000,
        },
        {
          targets: [this.slider],
          alpha: { from: 1, to: 0 },
          ease: Phaser.Math.Easing.Quadratic.Out,
          duration: 250,
          delay: 100,
          onComplete,
        },
      ],
    });
  }

  deactivateUserInput() {
    this.timeout.disable();
    this.userInputEnabled = false;
    this.scene.input.off('pointerdown', this.handlePointerDown, this);
  }

  addDragListeners() {
    this.scene.input.on('pointermove', this.handlePointerMove, this);
    this.scene.input.on('pointerup', this.handlePointerUp, this);
    this.scene.input.on('gameout', this.handlePointerUp, this);
  }

  removeDragListeners() {
    this.scene.input.off('pointermove', this.handlePointerMove, this);
    this.scene.input.off('pointerup', this.handlePointerUp, this);
    this.scene.input.off('gameout', this.handlePointerUp, this);
  }

  removeInputListeners() {
    this.scene.input.off('gameout', this.handlePointerUp, this);
    this.removeDragListeners();
  }

  onScenePaused() {}
  onSceneResumed() {}
  onSceneUpdate(time, delta) {
    if (this.trackForSwipe) {
      if (this.scene.input.activePointer.y < this.trackForSwipe) {
        if (this.trackForSwipe - this.scene.input.activePointer.y > this.swipetriggerDistance) {
          this.handleSwipeComplete();
        }
      } else this.trackForSwipe = this.scene.input.activePointer.y;
    }
  }
  endState() {
    if (this.timeout) {
      this.timeout.destroy();
      this.timeout = null;
    }
  }
}

class PlayfulStretchingCharacter extends SpinePlugin.SpineGameObject {
  constructor(scene, x, y, id, animal) {
    super(scene, scene.spine, x, y, id);
    scene.add.existing(this);
    this._stretchStage = 1;
    this._isIdle = true;
    this._animal = animal;

    if (this.findSkin('normal')) this.setSkinByName('normal');
    this._setAnimation();
  }

  set lipflap(value) {
    console.log('lipflap : ' + value);
    if (value && this.findSkin('lipflap')) {
      this.setSkinByName('lipflap');
    } else if (this.findSkin('normal')) {
      this.setSkinByName('normal');
    }
  }

  set stretchStage(value) {
    this._stretchStage = value;
    if (this._stretchStage < 4) this._setAnimation();
  }

  get stretchStage() {
    return this._stretchStage;
  }

  set idle(value) {
    this._isIdle = value;
    this._setAnimation();
  }

  get idle() {
    return this._isIdle;
  }

  set animProgress(value) {
    const time = this._trackedAnimationData.duration * 0.7 * value;
    this._trackedAnimation.trackTime = time;
  }

  _setAnimation() {
    if (this._isIdle) {
      const anim = `stretch_idle_${this._stretchStage}${this._animal ? '_' + this._animal : ''}`;
      this._trackedAnimation = this.state.setAnimation(0, anim, true);
      this._trackedAnimationData = this.findAnimation(anim);
      this.timeScale = 1;
    } else {
      const anim = `stretch_interact_${this._stretchStage}${
        this._animal ? '_' + this._animal : ''
      }`;
      this._trackedAnimation = this.state.setAnimation(0, anim, false);
      this._trackedAnimationData = this.findAnimation(anim);
      this.timeScale = 0;
    }
  }
}
